import SeoContext from '../../lib/seo-context';
import { fetchAPI } from '../../lib/api';
import Photo from '../../components/photo';
import Link from 'next/link';
import Layout from '../../components/layout';
import HeroSubpage from '../../components/hero-subpage';

import Cta from '../../components/cta';
import { Merge } from '../../lib/helper';
import { useGlobalContext } from '../../lib/global-context';
import ContentBlock from '../../components/content-block';
import ContentBox from '../../components/content-box';
import Features from '../../components/features';
import PhotoGallery from '../../components/photo-gallery';

const Category = (props) => {
    // const { state } = useGlobalContext();
    const { pageProps, global } = props;
    if (!pageProps) {
        return '';
    }

    const seo = Merge(global.seo, pageProps.seo);
    seo.canonicalURL = `${process.env.NEXT_PUBLIC_SITE_URL}/category/${pageProps.slug}`;
    return (
        <SeoContext.Provider value={seo}>
            <Layout
                footerClass="skew-maturity-100"
                languageData={{ originalSlug: pageProps.originalSlug, languages: pageProps.localizations }}
            >
                <HeroSubpage
                    image={pageProps.boxPhoto}
                    content={`<h1>${pageProps.title}</h1>` + pageProps.description}
                ></HeroSubpage>

                <section>
                    <div className="container">
                        <div className="grid grid-cols-1 m-10 mt-32 md:grid-cols-2 lg:grid-cols-3 gap-20">
                            {pageProps.products.data.map((entry) => (
                                <div
                                    key={entry.id.toString()}
                                    className="rounded-[0.25rem] shadow-lg border-[1px] border-maturity p-8 pt-0 bg-white"
                                >
                                    {entry.attributes.cover.data && (
                                        <div className="h-[22rem] relative -mt-10 z-30 text-center flex items-center justify-center">
                                            <Photo
                                                layout="fill"
                                                objectFit="contain"
                                                image={entry.attributes.cover}
                                            ></Photo>
                                        </div>
                                    )}

                                    <strong className="text-action mt-4 block uppercase">
                                        {entry.attributes.title}
                                    </strong>
                                    <span
                                        className="block my-4 "
                                        dangerouslySetInnerHTML={{
                                            __html: entry.attributes.listDescription
                                                ? entry.attributes.listDescription
                                                : entry.attributes.description
                                        }}
                                    ></span>
                                    <Link href={`/products/${entry.attributes.slug}`}>
                                        <a className="btn action-border">{entry.attributes.title}</a>
                                    </Link>
                                </div>
                            ))}
                        </div>

                        {pageProps.sections.map((section) => {
                            switch (section.__component) {
                                case 'layout.feature-list':
                                    return <Features key={`feat-${section.id}`} {...section} />;
                                case 'layout.content-block':
                                    return (
                                        <ContentBlock
                                            key={'content-block-' + section.id}
                                            settings={section}
                                        />
                                    );
                                case 'layout.content-box':
                                    return (
                                        <ContentBox key={'content-box-' + section.id} settings={section} />
                                    );
                                case 'layout.gallery':
                                    return (
                                        <PhotoGallery
                                            key={`gallery-${section.id}`}
                                            {...section}
                                            className="px-10"
                                        ></PhotoGallery>
                                    );
                            }
                        })}
                    </div>
                </section>

                <Cta skewBottom={false} className="bg-maturity-100 relative pt-24 pb-8 text-center">
                    <p className="text-trust-900 text-3xl normal-case py-8 w-2/3 mx-auto font-semibold">
                        Do you want to know more about our products?
                    </p>
                    <Link href="/contact">
                        <a className="btn action-full !text-base !px-10 !py-4">Let&apos;s get in touch</a>
                    </Link>
                </Cta>
            </Layout>
        </SeoContext.Provider>
    );
};

export async function getStaticPaths({ locales }) {
    const paths = [];
    await Promise.all(
        locales.map(async (locale) => {
            const results = await fetchAPI('/product-types', { locale, populate: 'deep,1' });

            return results.data.map((page) => {
                return paths.push({
                    params: {
                        slug: page.attributes.slug
                    },
                    locale
                });
            });
        })
    );

    return {
        paths,
        fallback: true
    };
}

export async function getStaticProps({ params, locale }) {
    try {
        const result = await fetchAPI(`/product-type/by-slug/${params.slug}`, {
            populate: 'deep,3',
            locale
        });

        return {
            props: { pageProps: result.data.attributes },
            revalidate: Number(process.env.NEXT_PUBLIC_PAGE_REVALIDATION) || 100
        };
    } catch (e) {
        console.log('got an error', e.message);
        return { notFound: true };
    }
}

export default Category;
